import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { PropuestasService } from './propuestas.service';


@Injectable()
export class DashboardService {

  constructor(private _propuestaService: PropuestasService) { }
  total: number;
  private dataSetChangeSource: EventEmitter<object> = new EventEmitter();
  dataSetChanged$ = this.dataSetChangeSource.asObservable();
  private datosFunnel: Array<Object> = [
    { name: 'POR HACER', value: 0 },
  ];
  private datosCircle: Array<Object> = [];
  private datosHorizontal : Array<Object> = [];

  getEstadisticas(params) {
    //  FUNNEL
    this._propuestaService.estadisticaEstadoPropuestas(
      params
    ).subscribe(
      respuesta => {
        this.datosFunnel = [];
        this.total = 0;
        for (let key in respuesta) {
          this.datosFunnel.push({
            name: respuesta[key].descripcion,
            value: respuesta[key].cantidad
          });
          this.total += + respuesta[key].cantidad;
        }
        this.dataSetChangeSource.emit({ datos: this.datosFunnel, total: this.total, chart: 'Funnel' });
      }
    );
    // CIRCLE
    this._propuestaService.estadisticaActividades(
      params
    ).subscribe(
      respuesta => {
        this.datosCircle = [];
        this.total = 0;
        respuesta.data.forEach(element => {
          this.datosCircle.push({
            name: element.TipoIncidenciaDesc,
            value: element.cantidad
          });
          this.total += + element.cantidad;
        });
        this.dataSetChangeSource.emit({ datos: this.datosCircle, total: this.total, chart: 'Circle' });
      },
    );
    // HORIZONTAL
    this._propuestaService.estadisticaCotizacion(
      params
    ).subscribe(
      respuesta => {  
        this.datosHorizontal = [];
        this.total = 0;
        for (let key in respuesta) {
          this.datosHorizontal.push([respuesta[key].descripcion, respuesta[key].cantidad]);
          this.total += + respuesta[key].cantidad;
        }
        this.dataSetChangeSource.emit({ datos: this.datosHorizontal, total: this.total, chart: 'Horizontal' });
        console.log(this.datosHorizontal);
      }
    );
  }

  public getDataInicializador() {
    return this.datosFunnel;
  }

  public setCurrentDataSet(params, i?) {
    this.getEstadisticas(params);
  }

}
